import React, { FC, ReactNode } from 'react'
import styles from "../../assets/styles/layout.module.css"
import Header from './Header'
import Footer from './Footer'
import MobileHeader from './MobileHeader'
import { useGetPrimaryMenuQuery } from '../../utils/store/common/commonApi'

interface propTypes {
    children: ReactNode
}
const Layout: FC<propTypes> = ({ children }) => {
        const { data: primaryMenuData, isLoading } = useGetPrimaryMenuQuery({});
    return (
        <div className={styles.layoutMain}>
            <Header primaryMenuData ={primaryMenuData} isLoading ={isLoading} />
            <MobileHeader primaryMenuData ={primaryMenuData} isLoading ={isLoading} />
            <main>{children}</main>
            <Footer primaryMenuData ={primaryMenuData} isLoading ={isLoading} />
        </div>
    )
}

export default Layout